import './style/main.css'
import App from './app/App'

App()
